import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';

export type IdentifyPlayerParams = {
  playerId: string;
  show: boolean;
  seq: number;
};

export const useIdentifyPlayerMutation = () => {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (params: IdentifyPlayerParams) => {
      const token = await getToken();
      return identifyPlayer(params, token ?? '');
    },
  });
};

const identifyPlayer = async (params: IdentifyPlayerParams, token: string): Promise<void> => {
  const url = `${import.meta.env.VITE_API_URL}/player/${params.playerId}/identify`;
  await sendJSONRequest({
    url,
    method: METHOD.POST,
    body: { show: params.show, seq: params.seq },
    token,
  });
};
